export default [
    {
        path: '/supervision/conquest',
        name: 'conquest',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/supervision/Conquest.vue')
    }
]